import { basicResetReducer } from '@ackee/redux-utils';
import { AUTH_SESSION_END } from '@ackee/petrus';

import { entityReducer } from 'modules/entities';

export default basicResetReducer(entityReducer, AUTH_SESSION_END);
